import { noop } from "@common/helpers/function";
import { BillStatus as BillStatusEnum } from "@common/types/bill";
import { BillStatus } from "@components/bills/BillStatus";
import {
    FilterMultiselect,
    FilterMultiselectOption,
    FilterMultiselectValue,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import {
    BaseFilterProps,
    defaultBillStatuses,
} from "@components/pageHeader/filters/lib";

const BILL_STATUS_VALUES = Object.values(BillStatusEnum);

function isBillStatus(value: FilterMultiselectValue): value is BillStatusEnum {
    return BILL_STATUS_VALUES.some((status) => status === value);
}

export const ExternalBillStatusFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const options: FilterMultiselectOption[] = BILL_STATUS_VALUES.map(
        (status) => ({
            value: status,
            label: <BillStatus status={status} showText />,
            searchableLabel: status,
        }),
    );

    const statuses =
        filters.externalBillStatuses && filters.externalBillStatuses.length > 0
            ? filters.externalBillStatuses
            : defaultBillStatuses;

    return (
        <FilterMultiselect
            inDropdown={false}
            searchable={false}
            options={options}
            value={statuses}
            onChange={(val) => {
                onChange({ externalBillStatuses: val.filter(isBillStatus) });
            }}
            name="externalBillStatuses"
            onBlur={noop}
        />
    );
};
